import React from "react";
import "../components/ProductosYServicios.css";
import factoring from "../assets/img/factoringv2movil.jpg";

import { NavLink } from 'react-router-dom';
import FormularioWeb from "../components/FormularioWeb.jsx";
import Footer from "../components/Footer.jsx";

const ProductosYServicios = () => {
  return (
    <div>
      <div className="bannerProductosYServicios">
        <h1 className="bannerProductosYServicios-title">
          Productos y Servicios
        </h1>
      </div>
      <div className="containerBannerPYS">
        <p className="textoBannerPYS">
          La mayor garantía se respalda en la confianza de los clientes que han
          contado con nuestro apoyo financiero de forma ágil y oportuna, a
          través de una excelente gestión de profesionales con años de
          experiencia en el negocio.
        </p>
      </div>
      <div className="containerPyS">
        <h1 className="titlePyS">
          Productos y servicios a la medida de tus necesidades
        </h1>
        <div className="gridPyS">
          <div className="boxPyS">
            <img src={factoring} alt="Factoring" />
          </div>
          <div className="boxPyS">
            <div className="box-titlePyS">Factoring</div>
            <NavLink className="linkPyS" to="/factoring">
              Factoring 
              <span className="link-iconPyS">
                <i className="fas fa-arrow-circle-right"></i>
              </span>
            </NavLink>
            <NavLink className="linkPyS" to="/factoringinternacional">
              Factoring Internacional <span className="link-iconPyS">
                <i className="fas fa-arrow-circle-right"></i>
              </span>
            </NavLink>
          </div>        
        </div>
      </div>
      <div className="formularioPYS">
      <h2>¿Tienes facturas pendientes de cobro?</h2>
      <FormularioWeb /></div>
      <Footer />
    </div>
  );
};

export default ProductosYServicios;
